
export const START_HIS = 'start_his'
export const TOAST :any = {
    duration: 10000,  // Duration the toast is visible
    position: 'bottom-right',  // Position of the toast
    style: {
        background: '#2C3B65',  // Light yellow background
        color: 'white',  // Text color
    },
}
export const DOCTOR_ROLE_ID = "4";